// import "./loader.css";
const LoaderSpinner = () => {
  return (
    <>
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    </>
  );
};

export default LoaderSpinner;
